import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import classNames from "classnames";
import { useState } from "react";
import { useParams } from "react-router";
import PDFViewer from "../components/Common/PDFViewer";
import DashboardLayout from "../components/DashboardLayout/DashboardLayout";
import InternalError from "../components/Errors/InternalError";
import Loading from "../components/Loading";
import { useDocument, useProcessing } from "../components/Orion/OrionQueries";
import ResultForm from "../components/Orion/Review/ResultForm";
import ProcessingPageHeader from "../components/PageHeader/ProcessingPage";
import ChatPdf from "../components/Sirius/ChatPdf";
import useSession from "../components/useSession/useSession";

export function ProcessingPage() {
  const [selectedTab, setSelectedTab] = useState(0);
  const { data: session } = useSession();

  let params = useParams();
  const coreIdx = Number(params.coreIdx) || 0;
  const processingId = params.processingId as string;

  const { data: processing, isError, isLoading } = useProcessing(processingId);

  const docPages =
    processing?.review?.analysis?.[coreIdx].page_subset ?? undefined;
  const documentId = processing?.review?.analysis?.[coreIdx].document_id;
  const document = processing?.documents.find((doc) => doc._id === documentId);
  const asset = processing?.asset;
  const { data: documentUrl } = useDocument(documentId);
  const chatPdf =
    !!processing && session?.OrionChatGroups.includes(processing.workspace_id);

  function getContent() {
    if (isError) {
      return <InternalError />;
    } else if (isLoading) {
      return <Loading />;
    } else if (!(processing && document && asset)) {
      return <InternalError />;
    } else {
      return (
        <div className="flex flex-1 w-full gap-6 overflow-hidden">
          <PDFViewer
            title={document.name ?? undefined}
            fileUrl={documentUrl?.url}
            pages={docPages}
            className="w-1/2"
          />
          <div className="w-1/2 flex flex-col overflow-hidden">
            <div
              className={classNames(
                "flex flex-col flex-1 bg-gray-50 overflow-hidden",
                {
                  "p-4": selectedTab === 1,
                  relative: selectedTab === 0,
                }
              )}
            >
              {selectedTab === 1 && chatPdf && (
                <ChatPdf
                  processing={processing.review?.analysis[coreIdx] ?? {}}
                  assetId={asset._id}
                />
              )}
              {selectedTab === 0 &&
                (processing.result && processing.review && processing.config ? (
                  <>
                    <ResultForm
                      processing={processing}
                      coreIdx={coreIdx}
                      key={processing.updated_date}
                    />
                    <div className="absolute -bottom-2 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent pointer-events-none" />
                  </>
                ) : (
                  <Loading />
                ))}
            </div>
          </div>
        </div>
      );
    }
  }

  return (
    <DashboardLayout>
      <Container
        maxWidth={false}
        className="flex flex-col overflow-hidden h-full"
      >
        <Stack
          spacing={2}
          className="flex flex-col my-2 overflow-hidden h-full"
        >
          {processing && (
            <ProcessingPageHeader
              asset={asset!}
              document={document!}
              chatPdf={!!chatPdf}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
            />
          )}
          {getContent()}
        </Stack>
      </Container>
    </DashboardLayout>
  );
}
